<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-hierarchy`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M32 9a8 8 0 10-10 7.748V23H10a3 3 0 00-3 3v6.29a7 7 0 104.001 0L11 27h26v5.29a7 7 0 104.001 0L41 26a3 3 0 00-3-3H26v-6.252c3.45-.888 6-4.02 6-7.748zm4 30a3 3 0 116 0 3 3 0 01-6 0zM9 36a3 3 0 100 6 3 3 0 000-6zM20 9a4 4 0 118 0 4 4 0 01-8 0z"/></svg>
</template>
<script>

export default {
  name: 'IconHierarchy',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
